import type { Label } from 'types/Global';

import { PATH, PATH_NAME } from '../constants/Routes'; // Must be relative because of Cypress
import { ALL_LANGUAGES, DEFAULT_LANGUAGE } from '../constants/LanguageConstants';

import { Location } from './Location';

/** Return translated message: current language, or dealer's language, or english, or first language available */
export const getI18nMessage = (langToUse: string, dealerLang: string, messages: Record<string, string> = {}) =>
  messages[langToUse] ?? messages[dealerLang] ?? messages[DEFAULT_LANGUAGE] ?? Object.values(messages).shift();

export const uniq = <T>(array: Array<T>): Array<T> => [...new Set(array)];

export const redirect = (url: string) => {
  Location.assign(url);
};

export const hasSomeAttributes = (obj: Record<string, unknown>, attributes: Array<string>): boolean =>
  attributes.some((attribute) => obj?.[attribute]);

export const createDictionary = <T>(dictionary: Record<string, T>, defaultValue: T): Record<string, T> =>
  new Proxy(dictionary, {
    get: (target, name: string) => (name in target ? target[name] : defaultValue),
  });

export const getPathName = (): string => {
  const { pathname } = window.location;
  const [foundEntry] = Object.entries(PATH).find(([, pattern]) => pattern.match(pathname)) ?? [PATH_NAME.PAGE_404];
  return foundEntry;
};

export const createLabel = (value: string): Label =>
  ALL_LANGUAGES.reduce((acc, language) => ({ ...acc, [language]: value }), {});
